import React from 'react'
import {Grid, Typography, Link, Button } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import colors from '../../../colors';
import { sendGeneralRequest } from "../../../../features/generalRequest";
import { useSelector, useDispatch } from "react-redux";
import { texts } from '../../../general/texts';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';

const AddNewCardButton = () =>
{
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const dispatch = useDispatch()

    const handleButtonClick = () =>
    {
        dispatch(
            sendGeneralRequest({
              request: {token: globalDataSliceState.token, paymentMethod: "2", saveCard:true, value: "100", applicationID: 1},
              baseUrlKey: "services",
              endpoint: "CreditBalance",
            })
          );
    }
    return(
        <Grid container item md={4} xs={12} alignItems={'flex-end'}>
            <Button onClick={handleButtonClick} disableRipple={true} sx={{background:colors.white, textTransform:'none', color:colors.darkBlue,  '&:hover':{background:colors.white}}} >
                <Grid container justifyContent={'space-around'} alignItems={'flex-end'} columnGap={0.5} >
                    <Typography sx={{fontFamily:'GerberaBold', color:colors.darkBlue, fontSize:'0.9rem', width:'80px'}}>{texts['button-add-card']}</Typography>
                    <CreditCardIcon />
                </Grid>
            </Button>
        </Grid> 
    )
}

export default AddNewCardButton